// extracted by mini-css-extract-plugin
export default {"main":"sortIcon_main__njXE4","down":"sortIcon_down__Z1OH3","up":"sortIcon_up__yLkyW"};